import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import CommonModal from 'components/elements/modals/CommonModal';
import ChangeEmailForm
  from 'components/dashboard/security-content/ChangeEmailForm';

import './ChangeEmailModal.css';

function ChangeEmailModal(props) {
  const {  open, onClose, changeEmailSuccess } = props;
  const { t } = useTranslation();

  return (
    <CommonModal
      className="change-email-modal__component"
      open={open}
      onClose={onClose}
    >
      <div className="header">{t("Change the email for your personal account")}</div>

      {!changeEmailSuccess &&
        <ChangeEmailForm />
      }

      {changeEmailSuccess &&
        <div className="success-message">
          {t("You will be logged out. We have just sent you an email to confirm your new email address.")}
        </div>
      }

      <div
        className="cancel-button"
        onClick={onClose}
        role="button"
        tabIndex={-1}
      >
        {!changeEmailSuccess ? t("Cancel") : t("Close")}
      </div>
    </CommonModal>
  );
}

ChangeEmailModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  changeEmailSuccess: PropTypes.object,
};

ChangeEmailModal.defaultProps = {
  open: null,
  changeEmailSuccess: null,
};

const mapStateToProps = state => (
  {
    changeEmailSuccess: state.usersReducer.changeEmailSuccess,
  }
);

export default connect(
  mapStateToProps,
  {},
)(ChangeEmailModal);
